import React, { useState } from 'react';

import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import {
  ArrowRight,
} from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { Field } from '@/components/ui/Input';
import PhoneField from '@/components/ui/PhoneField';
import { useToast } from '@/components/ui/Toast';

import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export default function CompleteProfile() {

  const { user, updateUser, } = useAuth();

  const navigate = useNavigate();

  const location = useLocation();

  const redirectTo =
    location.state?.redirectTo || '/';

  const { toast } = useToast();

  const [phone, setPhone] = useState(
    user?.phone || ''
  );

  const [loading, setLoading] =
    useState(false);

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      await api.put(
        '/auth/complete-profile',
        { phone }
      );

      // update local user cache

      const storedUser = JSON.parse(
  localStorage.getItem('kba_user')
);

const updatedUser = {
  ...storedUser,
  phone,
};

localStorage.setItem(
  'kba_user',
  JSON.stringify(updatedUser)
);
updateUser({
  phone,
});

      toast({
        title: 'Profile Updated',
        description:
          'Mobile number saved successfully.',
        variant: 'success',
      });

      navigate(redirectTo);

    } catch (err) {

      toast({
        title: 'Update Failed',
        description:
          err.response?.data?.detail ||
          'Something went wrong',
        variant: 'destructive',
      });

    } finally {

      setLoading(false);
    }
  };

  return (
   <div className="max-w-md mx-auto py-16 px-6">

      <div className="text-[10px] uppercase tracking-[0.25em] text-volt mb-3">
        Complete Profile
      </div>

      <h1 className="font-heading font-black text-4xl sm:text-5xl uppercase tracking-tight leading-none">
        Add your<br />mobile number.
      </h1>

      <p className="mt-3 text-white/50 text-sm">
        Please enter your contact number to continue booking courts and managing your reservations.
      </p>

      <form
        onSubmit={handleSubmit}
        className="mt-10 space-y-5"
      >

        <Field
          label="Mobile Number"
          htmlFor="phone"
        >

          <div className="relative">

            <PhoneField
              value={phone}
              onChange={setPhone}
              defaultCountry="IN"
              required
              placeholder="98765 43210"
              testId="completeprofile-phone"
            />

          </div>

        </Field>

        <Button
          type="submit"
          className="w-full"
          disabled={loading}
        >
          {loading ? (
            'Saving…'
          ) : (
            <>
              Continue Booking
              <ArrowRight size={16} />
            </>
          )}
        </Button>

      </form>

    </div>
  );
}